// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const companyClaManagersQuery = gql`
  query companyClaManagers(
    $companySFID: String!
    $projectSFID: String!
    $withProjectLogoUrl: Boolean!
  ) {
    companyClaManagers(companySFID: $companySFID, projectSFID: $projectSFID) {
      approvedOn
      email
      lfUsername
      logoUrl
      name
      projectId
      projectName
      projectLogoUrl @include(if: $withProjectLogoUrl)
      projectSfid
      userSfid
    }
  }
`;
